import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from '../pages/Login';
import Register from '../pages/Register';
import VerifyEmail from '../pages/VerifyEmail';
import Dashboard from '../pages/Dashboard';
import Chat from '../pages/Chat';
import ProtectedRoute from '../components/ProtectedRoute';
import ApiKeys from '../pages/ApiKeys';
import Subscription from '../pages/Subscription';
import Usage from '../pages/Usage';
import ScriptGenerator from '../pages/ScriptGenerator';
import Profile from '../pages/Profile';
import PaymentHistory from '../pages/PaymentHistory';
import ForgetPassword from '../pages/ForgetPassword';

const UserRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
<Route path="/forgot-password" element={<ForgetPassword/>} />      
      {/* Protected Routes */}
      <Route 
        path="/" 
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/chat" 
        element={
          <ProtectedRoute>
            <Chat />
          </ProtectedRoute>
        } 
      />
       <Route 
        path="/api-keys" 
        element={
          <ProtectedRoute>
            <ApiKeys />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/subscription" 
        element={
          <ProtectedRoute>
            <Subscription />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/usage" 
        element={
          <ProtectedRoute>
            <Usage />
          </ProtectedRoute>
        } 
      />
       <Route 
        path="/script-generator" 
        element={
          <ProtectedRoute>
            <ScriptGenerator />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/profile" 
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/payment-history" 
        element={
          <ProtectedRoute>
            <PaymentHistory />
          </ProtectedRoute>
        } 
      />
    </Routes>
  );
};

export default UserRoutes;